<ng-template [ngIf]="isLoadingResults">
  <app-loading></app-loading>
</ng-template>
<div class="note-container">
  <div class="d-flex mt-1 ">
    <form [formGroup]="creaNotaForm">
      <div class="grid formgrid p-fluid ">
        <div  class="field col-12">
          <label for="note" >Nuova nota</label>
          <span class="p-input-icon-left">
            <i class="pi pi-info-circle"></i>
            <textarea id="note" rows="5" formControlName="contenuto" [autoResize]="true"  pInputTextarea ></textarea>
          </span>
        </div>
      </div>
     
    </form>
  
</div>
<div class="flex justify-center" style="justify-content: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
      styleClass="p-button-warning"></p-button>
    <p-button  icon="pi pi-check" label="Conferma"
      class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isLoadingResults || !creaNotaForm.valid"></p-button>
</div>

